var logo = document.querySelector(".logo");
function createMessage(text) {
    var isError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var div = document.createElement("div");
    div.className = isError ? "message error-message" : "message";
    div.textContent = text;
    document.body.append(div);
}
var promise1 = new Promise(function(resolve, reject) {
    logo.addEventListener("click", function() {
        resolve("Promise was resolved!");
    }, {
        once: true
    });
});
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        reject(new Error("Promise was rejected!"));
    }, 3000);
});
promise1.then(function(msg) {
    return createMessage(msg);
}).catch(function(err) {
    return createMessage(err, true);
});
promise2.then(function(msg) {
    return createMessage(msg);
}).catch(function(err) {
    return createMessage(err, true);
});

//# sourceMappingURL=index.ebf78519.js.map
